export default {
  files: [],
  file: {},
  pedding_files: 0,
  pagination: {
    current_page: 1,
    per_page: 15,
  },
  estrutura: [],
  loading: false,
};
